import { render, staticRenderFns } from "./TreeStorageItem.vue?vue&type=template&id=150fdc1a&scoped=true&"
import script from "./TreeStorageItem.vue?vue&type=script&lang=ts&"
export * from "./TreeStorageItem.vue?vue&type=script&lang=ts&"
import style0 from "./TreeStorageItem.vue?vue&type=style&index=0&id=150fdc1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150fdc1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VListItemTitle,VRow,VTextField})
